/**
 * Stone Investment Property Features
 *
 * Stone-themed wrapper for the core PropertyFeatures component.
 * Applies Cormorant Garamond headings and greyscale palette.
 */

'use client';

import { PropertyFeatures, type PropertyFeaturesProps } from '@/components/properties';

export type StonePropertyFeaturesProps = PropertyFeaturesProps;

export function StonePropertyFeatures(props: PropertyFeaturesProps) {
  return (
    <div
      className="
        relative
        font-['Montserrat',-apple-system,BlinkMacSystemFont,'Segoe_UI',sans-serif]
        [&_h2]:font-['Cormorant_Garamond','Georgia',serif]
        [&_h3]:font-['Cormorant_Garamond','Georgia',serif]
        **:rounded-none
      "
    >
      <PropertyFeatures {...props} className="" />
    </div>
  );
}
